/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-11-25",
    versionChannel: "nightly",
    buildDate: "2024-11-25T00:06:48.949Z",
    commitHash: "5da69aaa04642af2593679d1761482b16955517e",
};
